import { useQuery } from "@tanstack/react-query";
import { BREV_SUPPORT_EMAIL } from "constants/index";
import agent from "server";

export const STRIPE_CONNECTION_ERROR =
  `Unable to connect to stripe. Try reloading, and if that doesn't work, contact support at ${BREV_SUPPORT_EMAIL}.`;

export const useStripeClientSecret = ({
  activeOrgId,
  enabled,
}: {
  activeOrgId: string;
  enabled: boolean;
}) => {
  const shouldFetchClientSecret = enabled && !!activeOrgId;
  const query = useQuery({
    queryKey: ["stripe-client-secret", activeOrgId],
    queryFn: async () => {
      const res = await agent.Billing.getClientSecret(activeOrgId);
      if (!res.success || !res.data?.clientSecret) {
        throw new Error(STRIPE_CONNECTION_ERROR);
      }

      return res.data.clientSecret;
    },
    enabled: shouldFetchClientSecret,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });

  const hasClientSecretError = shouldFetchClientSecret && !!query.error;

  return {
    clientSecret:
      shouldFetchClientSecret && !hasClientSecretError ? query.data || "" : "",
    clientSecretLoading:
      shouldFetchClientSecret && (query.isLoading || query.isFetching),
    clientSecretError: hasClientSecretError ? STRIPE_CONNECTION_ERROR : "",
  };
};
